import TypeAheadContainer from "../../../../components/formsAndTable/forms/formWidgets/typeAhead";

const TypeAhead = () => {
  return <TypeAheadContainer />;
};

export default TypeAhead;
